import React, {useEffect, useRef} from "react";
import Phone from '../../../assets/logo/phone.png'
import './Congrats.css'
import {Button} from "antd";
import {useLocation, useNavigate} from "react-router-dom";
import Header from "../../../components/header/Header";

export default function Congrats(){

    const navigate=useNavigate();
    const location=useLocation();

    const iccid = location.state.iccid ?? null;
    const eid = location.state.eid ?? null;

    const data=[iccid,eid];

    const isMountedRef = useRef(false);

    console.log(eid);
    console.log(iccid);

    const handleController=()=>{
        // try {
            // eslint-disable-next-line no-undef
            DataActivationController.doneSelected()
            navigate("/manage-subscription")
        // } catch (error) {
        //     message.error(ModalContent.GENERAL_ERROR_DESCRIPTION,1);
        //     console.log("An error occurred:", error);
        // }
    }

    useEffect(() => {

        // try {
            let paramsWithMeid = {
                eid: eid,
                iccid: iccid,
                alternateSmdpFqdn:"rsp.truphone.com"
            };

            // eslint-disable-next-line no-undef
            DataActivationController.dataPlanAccountUpdatedWithInfo(paramsWithMeid);
        // } catch (error) {
        //     message.error(ModalContent.GENERAL_ERROR_DESCRIPTION,1);
        //     console.error("Error occurred while updating data plan account info: ", error);
        // }

        // if (!isMountedRef.current) {
        //     isMountedRef.current = true;
        //     const payload = {
        //         level: "INFO",
        //         timestamp: new Date().toISOString(),
        //         pageName: LogContent.CONGRATS_PAGE,
        //         message: LogContent.CONGRATS_PAGE_MESSAGE
        //     };
        //
        //     submitWebSheetLogCollection(payload)
        //         .then(() => {
        //             console.log('Log submitted successfully');
        //         })
        //         .catch(error => {
        //             console.error('Error submitting log:', error);
        //         });
        // }

    }, data);

    return(
        <>
            <div style={{backgroundColor:"#E6E6E6",width:"100%"}}>
                <Header/>
            </div>

            <div className="congratsDiv">
                <img src={Phone} alt="Phone with SMS AlertPop"/>
                <h3>
                    Congratulations
                </h3>
                <div className="congrats">
                    The request is being processed. Please pay attention to your SMS notifications.
                </div>
                <Button
                    className="mainButton"
                    type="primary"
                    shape="round"
                    style={{ backgroundColor: "#f13434"}}
                    onClick={handleController}
                >
                    DONE
                </Button>
            </div>
        </>

    )
}